<router-outlet></router-outlet>


<a href="https://api.whatsapp.com/send/?phone=919607926665&text&app_absent=0" target="blank" class="btn-whatsapp-pulse btn-whatsapp-pulse-border">
	<i class='bx bxl-whatsapp bx-tada' ></i>
</a>